import { AppDocumentos } from "./appDocumentos.model";
import { AppImagenes } from "./appImagenes.model";
import { AppSolicitudesBolsa } from "./appSolicitidesBolsa.model";
import { AppSolicitudesCambioDatos } from "./appSolicitidesCambioDatos.model";
import { AppUsuario } from "./appUsuario.model";
import { BaseModel } from "./base/base.model";

export class AppSolicitudes extends BaseModel {
    public request1?: string;
    public createdAt?: Date;
    public user?: AppUsuario;
    public type!: any;
    public startDate!: Date;
    public endDate?: Date;
    public validator?: AppUsuario;
    public validatorHr?: AppUsuario;
    public state?: Number;
    public stateHr?: any;
    public stateDual?: any;
    public duration?: string;
    public dualValidationDate?: Date;
    public validationDate?: Date;
    public validationHrDate?: Date;
    public validatorObservations?: string;
    public employeeObservations?: string;
    public A3Doc?: string;
    public A3DocData?: string;
    public Doc?: AppDocumentos;
    public Image?: AppImagenes;
    public HolidayBag?: AppSolicitudesBolsa;
    public PersonalRequest?: AppSolicitudesCambioDatos;

}